export const WIDGET_HEADER_HEIGHT = 45
